module.exports = __webpack_public_path__ + "static/img/default_1.5023a237.png";